<template>
  <div
    class="component image"
    :data-type="type"
    data-viewport
    data-medusa-animation="image"
    @mouseenter="imageHover"
    @mouseleave="imageOut"
  >
    <div class="image__title" v-if="data.content.title" v-html="data.content.title"></div>
    <div class="image__picture" ref="image">
      <div class="image__picture-actual" :style="{ 'background-image': `url('${ data.content.image }')` }"></div>
    </div>
    <div class="image__price" v-if="data.content.price" v-html="data.content.price"></div>
    <div class="image__eyelet" v-if="data.content.eyelet" data-medusa-animation="slide">
      <div v-html="data.content.eyelet"></div>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap';
import WebGLImage from '@/scripts/webgl/WebGLImage';
import audio from '@/scripts/audio';
import { isMobile } from '../scripts/utils';

export default {
  name: 'ImageBlock',

  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    type: {
      type: String,
      required: false,
      default: () => 'full',
    },
    first: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasScale: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      audio: null,
      WebGLImage: null,
      hover: null,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.WebGLImage = new WebGLImage(
        this,
        this.$refs.image,
        this.data.content.image,
        this.data.content.resource,
      );
      if (isMobile()) this.imageHover(true);
    });
  },

  methods: {
    imageHover(skip = false) {
      if (!this.data.content.price) return;
      this.WebGLImage.buyIt.alpha = 1;
      this.hover = gsap.to(this.WebGLImage.buyIt, {
        alpha: 0,
        yoyo: true,
        repeat: -1,
        ease: 'steps(1)',
        duration: 0.5,
      });
      if (!skip) audio.play('buyit');
    },
    imageOut() {
      if (!this.data.content.price) return;
      gsap.killTweensOf(this.WebGLImage.buyIt);
      this.WebGLImage.buyIt.alpha = 0;
    },
  },

  beforeDestroy() {
    this.WebGLImage.destroy();
  },
};
</script>

<style lang="scss" scoped>
.image {
  position: relative;
  width: 100%;

  &__picture {
    overflow: hidden;
  }

  &__picture-actual {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
  }

  &[data-type="full"] {
    padding: $vertical-padding 0;

    .image__picture {
      width: 100%;
      height: 80vh;
      height: calc(var(--vh, 1vh) * 100);
    }
  }

  &[data-type="big"] {
    padding: $vertical-padding $horizontal-padding;

    @include mq($until: ipadL) {
      padding: $mobile-vertical-padding $mobile-horizontal-padding;
    }

    .image__picture {
      width: 100%;
      height: calc(1080px * var(--rw));

      @include mq($until: ipadL) {
        height: calc(540px * var(--rw));
      }
    }
  }

  &[data-type="half"] {
    padding: $vertical-padding $extra-horizontal-padding;

    @include mq($until: ipadL) {
      padding: $mobile-vertical-padding $extra-mobile-horizontal-padding;
    }

    .image__picture {
      width: calc(960px * var(--rw));
      height: calc(1080px * var(--rw));

      @include mq($until: ipadL) {
        width: 100%;
        height: calc(540px * var(--rw));
      }
    }
  }

  &[data-type="multiple"] {
    .image__picture {
      width: 100%;

      @include mq($until: ipadL) {
        height: 400px !important;
      }
    }
  }

  &__title {
    margin: 60px 0px;
    font-size: rem(65px);
    font-size: calc(65px * var(--rw));
    line-height: rem(65px);
    line-height: calc(65px * var(--rw));

    text-align: center;
  }

  &__price {
    position: absolute;
    width: 100%;
    bottom: 30px;
    font-family: 'VHS';
    margin: 60px 0px;
    font-size: rem(36px);
    font-size: calc(36px * var(--rw));
    line-height: rem(48px);
    line-height: calc(48px * var(--rw));

    text-align: center;

    display: none;
  }

  &__eyelet {
    margin: 20px 0px;
    overflow: hidden;

    @include mq($until: ipadL) {
      margin: -20px 0px;
    }
  }
}
</style>
